import { ContentPageTheme, PublicReviewWidget, PublicReviewWidgetReview, ReviewWidgetConfig } from "@/services/bedrock";
import {
  DUMMY_REVIEWS,
  DummyReview,
  SAMPLE_THEME,
  buildSampleSummary,
  findTheme,
  sortSampleReviews,
} from "../../components/sampleReviews";

const toPublicReview = ({
  approvedForSocial: _approvedForSocial,
  shareabilityScore: _shareabilityScore,
  ...review
}: DummyReview): PublicReviewWidgetReview => review;

const buildReviewList = (config: ReviewWidgetConfig): PublicReviewWidgetReview[] => {
  const filtered = config.approvedForSocialOnly
    ? DUMMY_REVIEWS.filter(review => review.approvedForSocial)
    : DUMMY_REVIEWS;
  return sortSampleReviews(filtered, config.reviewSortType).map(toPublicReview);
};

export const buildEmbeddedHighlightsPreviewData = (
  config: ReviewWidgetConfig,
  themes: ContentPageTheme[]
): PublicReviewWidget => {
  const theme = findTheme(themes, config.contentPageThemeId) ?? SAMPLE_THEME;

  const reviews = buildReviewList(config);
  const summary = buildSampleSummary(config);

  return {
    reviewSortType: config.reviewSortType,
    useCondensedQuotes: config.useCondensedQuotes,
    autoScrollEnabled: config.autoScrollEnabled,
    playerDisplayName: "Alex Smith",
    formUrl: "#write-a-review",
    reviewPageUrl: "#view-all-reviews",
    summary,
    theme,
    reviews,
  };
};
